/**
 * Pooja booking draft — the selection made on the details page (pooja +
 * package + add-ons) that the checkout page turns into a booking. Persisted
 * to localStorage so it survives the RequireAuth login redirect on
 * /pooja-energization/checkout, exactly like the cart store does.
 */

const KEY = `astro-pooja-booking:${import.meta.env.VITE_ENV ?? 'development'}`

export function saveBookingDraft(draft) {
  try {
    localStorage.setItem(KEY, JSON.stringify(draft))
  } catch {
    /* storage full/blocked — checkout will show the empty state */
  }
}

export function loadBookingDraft() {
  try {
    const raw = localStorage.getItem(KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function clearBookingDraft() {
  try {
    localStorage.removeItem(KEY)
  } catch {
    /* ignore */
  }
}
